<div class="card card-custom mb-4" [ngClass]="cssClasses">
    <!-- Header -->
    <div class="card-header pl-2 pr-5" [ngStyle]="{'border-bottom':'0'}">
        <div class="card-title text-primary font-weight-bold font-size-h6"> 
            <a (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="opportunity-body" [ngStyle]="{'cursor':'pointer'}">
                <img *ngIf="isCollapsed" src="./assets/media/svg/icons/General/Angle-double-left.svg" class="pr-1">
                <img *ngIf="!isCollapsed" src="./assets/media/svg/icons/General/Angle-double-bottom.svg" class="pr-1">
            </a>
            {{headingName}} 
        </div>
        <div class="card-toolbar">
            <div class="example-tools justify-content-center">
                <a class="btn btn-xs btn-icon btn-bg-light btn-icon-primary btn-hover-primary"  (click)="addOpportunity()">
                    <i class="fas fa-plus"></i>
                </a>
                <!--<a class="btn btn-xs btn-icon btn-bg-light btn-icon-primary btn-hover-primary" href="javascript:void(0)">
                    <i class="fas fa-filter"></i>
                </a>-->
            </div>
        </div>
    </div>
    <!-- Body -->
    <div id="opportunity-body" [ngbCollapse]="isCollapsed" class="card-body p-0 m-0 card-body-scroll">
        <ngx-spinner size="default" type="ball-spin-clockwise" name="dashboard-opportunity">  
            <p style="color: white">Fetching Data... </p>  
        </ngx-spinner>
        <div class="font-size-h6 text-center" *ngIf="isError">{{errorMessage}}</div>
        <!-- Opportunity Start -->
        <div class="card card-border rounded p-2 ml-2 mr-2 mb-2" *ngFor="let opportunity of opportunityList">
            <div class="d-flex align-items-center p-2">
                <!--<div class="symbol symbol-circle symbol-35 mr-3">
                    <img *ngIf="(opportunity.imageName == null || opportunity.imageName == '')" alt="Pic" src="./assets/media/stock-600x400/img-70.jpg">
                    <img *ngIf="(opportunity.imageName != null && opportunity.imageName != '')" alt="Pic" src="{{imageName}}">
                </div>-->
                <div class="d-flex flex-column flex-grow-1">
                    <a href="javascript:void(0)" class="text-dark-75 text-hover-primary font-weight-bold font-size-lg">{{opportunity.name}}-{{opportunity.serialNo}}</a>
                    <span class="text-muted font-weight-bold font-size-sm">
                        <ngb-progressbar type="success" [value]="opportunity.winProbability"></ngb-progressbar>
                    </span>
                </div>
                <div class="text-muted font-weight-bold font-size-sm pl-2 pr-4 pt-6">{{opportunity.winProbability}}%</div>
                <a class="btn btn-xs btn-icon btn-bg-light btn-icon-primary btn-hover-primary" 
                    href="javascript:void(0)"
                    routerLink="/opportunity-dashboard/{{opportunity.opportunityId}}" title="Opportunity Dashboard">
                    <img src="./assets/media/svg/icons/General/Arrow-right.svg"> 
                </a>
            </div>
            <div class="d-flex align-items-center p-2">
                <div class="d-flex flex-column flex-grow-1">
                    <span class="text-muted font-size-sm">
                        <img src="./assets/media/svg/icons/General/settings_1.svg" class="pl-3 pr-4" title="Status"> 
                        {{opportunity.status}}
                    </span>
                    <span class="text-muted font-size-sm pt-2">
                        <img src="./assets/media/svg/icons/General/money_2.svg" class="pl-3 pr-4" title="Estimated Revenue"> 
                        {{opportunity.estimatedRevenue}}
                    </span>
                    <span class="text-muted font-size-sm pt-2">
                        <img src="./assets/media/svg/icons/General/Calendar.svg" class="pl-3 pr-4" title="Closure Date">
                        {{opportunity.closureDate}}
                    </span>
                    <span class="text-muted font-size-sm pt-2">
                        <img src="./assets/media/svg/icons/General/people_outline_24px.svg" class="pl-3 pr-4" title="Contacts">
                        <span class="label label-light-primary mr-2 mb-2 p-2" *ngFor="let contact of opportunity.contacts" ngbTooltip="{{contact.name}}">
                            {{contact.initials}}
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <!-- Opportunity End -->
    </div>
</div>
